import { Box, Flex, type BoxProps } from '@chakra-ui/react';
import NextImage from 'next/image';
import ReactMarkdown from 'react-markdown';
import React from 'react';

export type DescriptionSettings = {
  title?: string | null;
  text?: string | null; // markdown形式の説明文
};

export default function SpecialPageDescription({
  title,
  text,
  containerProps,
}: DescriptionSettings & {
  containerProps?: BoxProps;
}) {
  const trimmedTitle = title?.trim();
  const trimmedText = text?.trim();

  if (!trimmedTitle && !trimmedText) return null;

  return (
    <Box {...containerProps}>
      <Flex flexDirection="column" gap={1}>
        {trimmedTitle && (
          <Flex fontSize={15} fontWeight="bold" alignItems="center">
            <NextImage
              src="/images/icon_md_lightbulb.svg"
              width={24}
              height={24}
              alt=""
            />
            {trimmedTitle}
          </Flex>
        )}
        {trimmedText && (
          <Box fontSize="sm" whiteSpace="pre-wrap">
            <ReactMarkdown>{trimmedText}</ReactMarkdown>
          </Box>
        )}
      </Flex>
    </Box>
  );
}
